module.exports = "<label class=\"switch\">\n  <input type=\"checkbox\" [(ngModel)]=\"enabled\" (click)=\"toggleClicked()\">\n  <span class=\"slider round\"></span>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/toggle-button/toggle-button.component.html
// module id = ../../../../../src/app/toggle-button/toggle-button.component.html
// module chunks = main